var map = {
	"./en_us.png": "ff49",
	"./ja_jp.png": "6cbe",
	"./ko_kr.png": "9d3a",
	"./ms_my.png": "c43b",
	"./th_th.png": "5c55",
	"./vi_vn.png": "18b4",
	"./zh_cn.png": "33ce",
	"./zh_hk.png": "4f25"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f492";